import { BackButton } from "@/components/BackButton";
import { StokvelWallet } from "@/components/StokvelWallet";

// Public-facing "Stationery Stokvel" page. Banking details never render here —
// they live in the member's profile (My Account → Stokvel Wallet) only.
export default function StokvelPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="stokvel-page">
      <div className="mb-4">
        <BackButton to="/account" label="Back to my account" testId="stokvel-back-button" />
      </div>
      <StokvelWallet showBanking={false} brand="Stationery Stokvel" />
    </div>
  );
}
